const browserUrl = {
  setFragments: function (fragments) {
    let newLocation = '';

    if (fragments) {
      newLocation = window.location.pathname + fragments;
    }

    window.history.replaceState(null, null, newLocation);
  }
};

export default browserUrl;
